// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"0a2b3603","273":"76fbd65a","631":"88595969","722":"8c7ad1af","804":"02011e72","811":"76fbd65a"}[chunkId] + ".chunk.css";
};